import { CONSENT_VERSION } from "./config";

/* ============================================================================
   The visitor's cookie choice for analytics.

   Stored in localStorage as {"choice":"granted"|"denied","version":1}.
   Until the visitor chooses, nothing is tracked and no analytics cookie is set
   (GDPR / Swedish ePrivacy rules: analytics cookies need prior consent).
   ========================================================================== */

const STORAGE_KEY = "tk_consent";
const listeners = new Set();

/* "granted" | "denied" | null (not asked yet, or asked with an older banner). */
export function getConsent() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
    return saved && saved.version === CONSENT_VERSION ? saved.choice : null;
  } catch (e) {
    return null; // private mode / storage blocked → treat as not asked
  }
}

export function setConsent(choice) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, version: CONSENT_VERSION }));
  } catch (e) { /* storage blocked: the choice lasts for this page only */ }
  listeners.forEach((fn) => fn(choice));
}

/* Call fn(choice) whenever the visitor changes their choice. Returns an unsubscribe function. */
export function onConsentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/* "Cookie settings" links in the footers call this to show the banner again. */
export const OPEN_CONSENT_EVENT = "tk:open-consent";
export function openConsentSettings() {
  window.dispatchEvent(new Event(OPEN_CONSENT_EVENT));
}
